export default __webpack_public_path__ + "static/media/CNo.46-1.051a0afd.jpg";